/***********************************************************************************
 **
 ** SAJAX
 **
 /**************************************************************************************/

// remote scripting library
// (c) copyright 2005 modernmethod, inc
var sajax_debug_mode = false;
var sajax_request_type = "POST";
var sajax_target_id = "";
var sajax_async_mode = true;
var sajax_failure_redirect = "";
var sajax_default_uri = "/ajax_tunnel.php";
var sajax_uri = "/ajax_tunnel.php";
var sajax_wait = 60000;

var enable_load = true;

/***
 * define modo assíncrono ou não para Ajax
 * @param mode
 */
function setAjaxASyncMode(mode) {
    sajax_async_mode = mode;
}

/***
 * Define timeout do ajax
 * @param timeout
 */
function setAjaxTimeout(timeout) {
    sajax_wait = timeout;
}

divName = '';
divCenter = 0;
divNameCenter = '';

SajaxLoadingCount = 0;

DefaultErrorMessage = 'Por favor entre em contato como administrador do sistema, através do email contato@personare.com.br';

function voidAction() {

}

/**
 * Async Ajax
 * @param template
 * @param formName
 * @param returnFunction
 */
function SendFormDataByAjaxRunTemplate(template, formName, returnFunction) {
    /* Async */
    setAjaxASyncMode(true);

    //returnFunction = SetDivContent
    divName = TemplateNameToDivName(template);

    formData = create_request_string(formName);

    //CreateScript(template)
    x_ReceiveFormDataByAjaxRunTemplate(template, formData, returnFunction);
}


/**
 * Async Ajax
 * @param template
 * @param formName
 * @param returnFunction
 */
function SendFormDataByAjaxRunTemplateHistory(template, formName, returnFunction) {
    /* Async */
    setAjaxASyncMode(true);

    divName = TemplateNameToDivName(template);
    formData = create_request_string(formName);

    if (!(returnFunction instanceof Function)) {
        returnFunction = '{"callback":' + returnFunction.callback.toString().strip() + ', "extra_data": "' + returnFunction.extra_data.toString().strip() + '"}';
    }

    //var data = "{'isForm': true, 'template': '" + template + "', 'params': '"+ formData +"', 'callback': "+ returnFunction.toString().strip() +"}";
    var data = "['" + template + "', '" + formData + "', " + returnFunction.toString().strip() + "]";

    var md5_data = base64_encode(data);
    conteudo(md5_data);
}

/**
 * Async Ajax
 * @param template
 * @param data
 * @param returnFunction
 */
function SendDataByAjaxRunTemplate(template, data, returnFunction) {
    /* Async */
    setAjaxASyncMode(true);

    divName = TemplateNameToDivName(template);

    x_ReceiveFormDataByAjaxRunTemplate(template, data, returnFunction);
}

/**
 * Async Ajax
 * @param template
 * @param params
 * @param returnFunction
 */
function SendDataByAjaxRunTemplateHistory(template, params, returnFunction) {
    /* Async */
    setAjaxASyncMode(true);

    if (!(returnFunction instanceof Function)) {
        returnFunction = '{"callback":' + returnFunction.callback.toString().strip() + ', "extra_data": "' + returnFunction.extra_data.toString().strip() + '"}';
    }

    var data = "['" + template + "', '" + params + "', " + returnFunction.toString().strip() + "]";
    var md5_data = base64_encode(data);

    conteudo(md5_data);
}

/**
 *
 * @param md5_data
 */
var conteudo = function(md5_data) {
    var data, data2;
    try {
        data = decodeURIComponent(md5_data);
        data = eval('(' + base64_decode(md5_data) + ')');
    } catch (e) {
        plog(e);
        return;
    }

    var template = data[0];
    var params = data[1];
    var returnFunction = data[2];

    divName = TemplateNameToDivName(template);

    x_ReceiveFormDataByAjaxRunTemplate(template, params, returnFunction);
};

/**
 *
 * @param templateName
 */
function TemplateNameToDivName(templateName) {
    while (templateName.indexOf('/') != -1)
        templateName = templateName.replace('/', '_');

    return templateName.toLowerCase();
}

/***
 * Async Ajax
 * @param formName
 * @param className
 * @param methodName
 * @param returnFunction
 */
function SendFormDataByAjaxRunMethod(formName, className, methodName, returnFunction) {
    /* Async */
    setAjaxASyncMode(true);
    sajax_target_id = '';

    form = jQuery('form[name='+formName+']'); //document[formName]; // eval('document.' + formName);

    if (className != '')
        createHiddenField(formName, 'mdl', className);

    if (methodName != '')
        createHiddenField(formName, 'cmd', methodName);

    var formData = create_request_string(formName);

    x_ReceiveFormDataByAjaxRunMethod(formData, returnFunction);
}

/***
 * Async Ajax
 * @param data
 * @param className
 * @param methodName
 * @param returnFunction
 */
function SendDataByAjaxRunMethod(data, className, methodName, returnFunction) {
    /* Async */
    setAjaxASyncMode(true);

    sajax_target_id = '';

    data += "&mdl=" + className + "&cmd=" + methodName;

    x_ReceiveFormDataByAjaxRunMethod(data, returnFunction);
}

/***
 * Sync Ajax
 * @param data
 * @param className
 * @param methodName
 */
function SendDataByAjaxRunMethodSync(data, className, methodName) {
    setAjaxASyncMode(false);

    data += "&mdl=" + className + "&cmd=" + methodName
    return x_ReceiveFormDataByAjaxRunMethodSync(data);
}

/***
 * Sync Ajax
 * @param template
 * @param data
 */
function SendDataByAjaxRunTemplateSync(template, data) {
    /* Async */
    setAjaxASyncMode(false);
    return x_ReceiveFormDataByAjaxRunTemplateSync(template, data);
}

/***
 * Sync Ajax
 * @param formName
 * @param className
 * @param methodName
 */
function SendFormDataByAjaxRunMethodSync(formName, className, methodName) {
    /* Async */
    setAjaxASyncMode(false);

    form = eval('document.' + formName);

    if (className != '')
        createHiddenField(formName, 'mdl', className)

    if (methodName != '')
        createHiddenField(formName, 'cmd', methodName)

    formData = create_request_string(formName)

    return x_ReceiveFormDataByAjaxRunMethodSync(formData);
}

/***
 *
 * @param content
 * @param auxDivName
 */
function SetDivContent(content, auxDivName) {

    if (auxDivName != false && typeof auxDivName != "undefined") {
        divName = auxDivName;
    }
    if (divNameCenter != '') {
        hideActiveX();
        jQuery('#' + divName).hide();
    }

    // console.log(divName);

    var $divName = jQuery('#' + divName).html(content);

    //POP
    if (popCurrent != null) {
        Pop.alignCenter();
    }

    if (divNameCenter != '') {
        PositionDiv(divNameCenter);
        divNameCenter = '';
        $divName.show();
    }
}